import React, { Suspense, lazy } from 'react';
import useAuth from 'hooks/useAuth';
import useUserStore from 'store/useUserStore';
import { Loader } from '@urbantxt/loader';

const LoggedOutRoutes = lazy(() => import('./LoggedOutRoutes'));
const LoggedInRoutes = lazy(() => import('./LoggedInRoutes'));
const MustChangePasswordRoutes = lazy(
  () => import('./MustChangePasswordRoutes'),
);

export default function AppRoutes() {
  const { isDone } = useAuth();
  const user = useUserStore(s => s.user);

  if (!isDone) {
    return <Loader theme="dark" isVisible fullscreen />;
  }

  let RoutesTree = LoggedOutRoutes;
  if (user && user.mustChangePassword) {
    RoutesTree = MustChangePasswordRoutes;
  } else if (user) {
    RoutesTree = LoggedInRoutes;
  }

  return (
    <Suspense fallback={<Loader theme="dark" isVisible fullscreen />}>
      <RoutesTree />
    </Suspense>
  );
}
